@let memberValue = member();
@let roleTitleKeyValue = roleTitleKey();
@let fullNameValue = fullName();

<div class="account-team-panel-member__header">
  <kds-avatar
    size="medium"
    variant="image"
    [firstName]="memberValue.firstName"
    [lastName]="memberValue.lastName"
    [photoUrl]="memberValue.photoUrl"
  />
  <div class="account-team-panel-member__info">
    <div class="account-team-panel-member__role" [kdsTooltip]="roleTitleKeyValue | translate" [hideIfNotTruncated]="true">
      {{ roleTitleKeyValue | translate }}
    </div>
    <div class="account-team-panel-member__name" [kdsTooltip]="fullNameValue" [hideIfNotTruncated]="true">
      {{ fullNameValue }}
    </div>
  </div>
</div>
@if (memberValue.email; as email) {
  <div class="account-team-panel-member__email">
    <i class="account-team-panel-member__email-icon fa-regular fa-envelope" aria-hidden="true"></i>
    <a
      href="mailto:{{ email }}"
      kds-link
      tooltipPosition="right-center"
      class="account-team-panel-member__email-link"
      [kdsTooltip]="email"
      [hideIfNotTruncated]="true"
    >
      {{ email }}
    </a>
  </div>
}
